import React, { useMemo } from 'react';
import { Table } from 'antd';

import { dayFormatType, formatDay } from '~helpers/day';

import Card from '../card';

export default function ReconciliationHistory({ t, reconciliationHistoryInfo = [] }) {
  const getColumns = useMemo(
    () => [
      {
        title: t('cms.reconciliation.lead_generation.detail.table.field.status'),
        dataIndex: 'currentStatus',
        key: 'currentStatus',
        width: '18%',
        render: (_, record) => (
          <span className="transfer__table-field">
            {record?.currentStatus
              ? t(
                  `cms.reconciliation.lead_generation.status.${record.currentStatus?.toLowerCase()}`,
                )
              : '-'}
          </span>
        ),
      },
      {
        title: t('cms.reconciliation.lead_generation.detail.table.field.update_by'),
        dataIndex: 'modifierName',
        key: 'modifierName',
        width: '16%',
        render: (_, record) => (
          <span className="transfer__table-field">{record?.modifierName ?? '-'}</span>
        ),
      },
      {
        title: t('cms.reconciliation.lead_generation.detail.table.field.update_at'),
        dataIndex: 'updatedAt',
        key: 'updatedAt',
        width: '16%',
        render: (_, record) => (
          <span className="transfer__table-field">
            {record?.updatedAt ? formatDay(dayFormatType.UKWITHHMS, record.updatedAt) : '-'}
          </span>
        ),
      },
      {
        title: t('cms.reconciliation.lead_generation.detail.table.field.invoice_number'),
        dataIndex: 'currentInvoiceNumber',
        key: 'currentInvoiceNumber',
        width: '14%',
        render: (_, record) => (
          <span className="transfer__table-field" style={{ width: 160 }}>
            {record?.currentInvoiceNumber ?? '-'}
          </span>
        ),
      },
      {
        title: t('cms.reconciliation.lead_generation.detail.table.field.notes'),
        dataIndex: 'note',
        key: 'note',
        width: '36%',
        render: (_, record) => (
          <div className="transfer__table-field" style={{ maxWidth: 400, minWidth: 160 }}>
            {record?.note ?? '-'}
          </div>
        ),
      },
    ],
    [],
  );

  return (
    <Card title={t('cms.reconciliation.lead_generation.detail.reconciliation_history.title')}>
      <If condition={reconciliationHistoryInfo.length === 0}>
        <div className="reconciliation-history__empty">
          {t('cms.reconciliation.lead_generation.reconciliation_history.empty')}
        </div>
      </If>
      <If condition={reconciliationHistoryInfo.length > 0}>
        <Table
          className="history-table-wrapper"
          columns={getColumns}
          dataSource={reconciliationHistoryInfo}
          pagination={false}
        />
      </If>
    </Card>
  );
}
